/**
 * 閱讀進度在整本作品中的比例，用於書庫卡片的進度條。
 * 只有一頁（或頁數不合法）時沒有可呈現的進度，回傳 0。
 */
export function readingProgressRatio(page: number, pageCount: number): number {
  if (!Number.isFinite(page) || !Number.isFinite(pageCount) || pageCount <= 1) return 0
  const last = Math.trunc(pageCount) - 1
  const clamped = Math.min(last, Math.max(0, Math.trunc(page)))
  return clamped / last
}

/** 書庫卡片能拿到的進度摘要：本機那一份是 StoredProgress，雲端那一份是清單項目附帶的摘要。 */
export interface ProgressSummary { page: number; updatedAt: number }

/**
 * 在本機那一份與雲端目錄項那一份之間挑出要顯示的進度。
 *
 * 兩份都有時取更新時間較新者；平手取雲端——已註冊作品以 D1 為準，平手時兩邊通常是
 * 同一筆推送成功後的鏡像，明講只是讓結果可判定。只有一份就用那一份，都沒有回 null。
 */
export function pickReadingProgress(
  local: ProgressSummary | null | undefined,
  cloud: ProgressSummary | null | undefined,
): ProgressSummary | null {
  if (local && cloud) return local.updatedAt > cloud.updatedAt ? local : cloud
  return local ?? cloud ?? null
}
